import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { icons } from "../../../../../../utils/icons"
import { useStyles } from "./styles"
import { ReportResend } from "./types"
import { useTranslation } from "react-i18next"

const ReportCard = ({ date, title, seeReport, sendReport, disable}: ReportResend) => {
    const styles = useStyles()
    const { t } = useTranslation()
    return (
        <Box sx={styles.container}>
            <Box sx={styles.date}>
                <Typography color={'c_grey.100'} variant="subtitle" fontWeight='500'>{title}</Typography>
                <Typography color={'c_grey.100'} variant="subtitle" fontWeight='500'>{date}</Typography>
            </Box>

            <Box sx={styles.actions}>
                {!!sendReport && <IconButton onClick={sendReport}><Tooltip title={title.includes('resultados') ? t('schedule.modal.resendQuestionnaireResultReport'):t('schedule.modal.resendReport')}>{icons('send-email')}</Tooltip></IconButton>}
                <IconButton disabled={disable ? disable:false} onClick={seeReport}><Tooltip title={title.includes('resultados') ? t('schedule.modal.displayQuestionnaireResultReport'):t('schedule.modal.displayReport')}>{icons('visibility')}</Tooltip></IconButton>
            </Box>
        </Box>
    )
}

export { ReportCard }